export function CloseIcon({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2073 6.20711C19.5978 5.81658 19.5978 5.18342 19.2073 4.79289C18.8167 4.40237 18.1836 4.40237 17.7931 4.79289L11.9939 10.5921L6.14427 4.84372C5.75035 4.45662 5.11721 4.46214 4.73011 4.85606C4.34301 5.24998 4.34853 5.88312 4.74245 6.27022L10.5796 12.0064L4.79306 17.7929C4.40253 18.1834 4.40253 18.8166 4.79306 19.2071C5.18358 19.5976 5.81675 19.5976 6.20727 19.2071L12.0061 13.4082L17.8554 19.1563C18.2493 19.5434 18.8825 19.5379 19.2696 19.1439C19.6567 18.75 19.6511 18.1169 19.2572 17.7298L13.4204 11.994L19.2073 6.20711Z"
        fill="inherit"
      />
    </svg>
  );
}
